module.exports = {
	// api: 'https://api-voucher-viva.onwardsmg.com/v1',
	// api: 'https://cdn.craffview.com/v1', // prod
	// api: `${process.env.REACT_APP_BAMBOO_API || 'http://localhost:3008/v1'}`,
	api: `${process.env.REACT_APP_BAMBOO_API || 'https://api-astro.craffview.com/v1'}`,
	apiQuery: `${process.env.REACT_APP_QUERY_API || 'https://api2.craffview.com/v1'}`,
	apiAlarm: `${'https://api.craffview.com/v1'}`,
	// apiAlarm: `${'https://d3mgbr7exrskcr.cloudfront.net/v1'}`, // prod
	version: `${process.env.REACT_APP_VERSION || '1.00.00'}`,
	apiHeaderXCraffviewEnv: `${process.env.REACT_APP_BAMBOO_CRAFFVIEW_ENV || 'development'}`,
	accountId: `${process.env.REACT_APP_ACCOUNT_ID || 'vivamax'}`,
	domainSuffix: `${process.env.REACT_APP_DOMAIN_SUFFIX || '.astro.craffview.com'}`,
	serviceAdmin: `${process.env.REACT_APP_SERVICE_ADMIN || 'https://astro.craffview.com/'}`,
	businessUnit: process.env.REACT_APP_BUSINESS_UNIT ? process.env.REACT_APP_BUSINESS_UNIT.split(',') : [],
};
